
import { Input, Tag, Tooltip } from '@chakra-ui/react';
import { PhoneIcon } from 'lucide-react';
import { PhoneStatusType } from 'types';
import useServerApi from 'hooks/useServerApi';
import { useEffect, useState } from 'react';
import { formatUSPhoneNumber } from 'utils/phone.js';



interface Props {
    phoneNumber: string | null;
    phoneStatus: PhoneStatusType;
    onBuyNumber: () => void;
    failureReason?: string | null | undefined;
}

const colorScheme: Record<PhoneStatusType, string> = {
    [PhoneStatusType.draft]: 'orange',
    [PhoneStatusType.pending_review]: 'yellow',
    [PhoneStatusType.in_review]: 'blue',
    [PhoneStatusType.twilio_approved]: 'green',
    [PhoneStatusType.twilio_rejected]: 'red',
    [PhoneStatusType.buy_number]: 'purple',
    [PhoneStatusType.demo_number]: 'purple',
};

const PhoneStatus = ({ phoneNumber, phoneStatus, onBuyNumber, failureReason }: Props) => {
    const [{ get }] = useServerApi();
    const [demoPhoneNumber, setDemoPhoneNumber] = useState<string | null>(null);
    useEffect(() => {
        async function fetchDemoNumber() {
            if (phoneStatus === PhoneStatusType.demo_number) {
                const [success, data] = await get(`/rest_endpoints/accounts/service_configuration/demo_phone_number`);
                if (success && data && data && data.phone_number) {
                    setDemoPhoneNumber(formatUSPhoneNumber(data.phone_number));
                }
            }
        }
        fetchDemoNumber();
    }, [phoneStatus, get]);

    if (phoneNumber) {
        return (
            <div className='flex items-center space-x-2'>
                <PhoneIcon className='w-4 h-4 text-muted-foreground' />
                <Input value={formatUSPhoneNumber(phoneNumber)} readOnly className='h-8' />
            </div>
        );
    }

    // If status is buy_number, make the tag clickable
    if (phoneStatus === PhoneStatusType.buy_number) {
        return (
            <div className='h-10 flex items-center'>
                <Tag
                    colorScheme={colorScheme[phoneStatus]}
                    fontWeight='bold'
                    textTransform='capitalize'
                    cursor='pointer'
                    onClick={onBuyNumber}
                    _hover={{ opacity: 0.8 }}
                >
                    {phoneStatus.split('-').join(' ')}
                </Tag>
            </div>
        );
    }
    if (phoneStatus === PhoneStatusType.demo_number) {
        return (
            <div className='h-10 flex items-center'>
                <Tooltip label={demoPhoneNumber ? "Call this number to test your agent" : ""} hasArrow placement="top">
                    <Tag
                        colorScheme={colorScheme[phoneStatus]}
                        fontWeight='bold'
                        textTransform='capitalize'
                        cursor='pointer'
                        onClick={onBuyNumber}
                        _hover={{ opacity: 0.8 }}
                    >
                        {demoPhoneNumber || phoneStatus.split('-').join(' ')}
                    </Tag>
                </Tooltip>
            </div>
        );
    }

    const tagElement = (
        <Tag
            colorScheme={colorScheme[phoneStatus]}
            fontWeight='bold'
            textTransform='capitalize'
        >
            {phoneStatus.split('-').join(' ')}
        </Tag>
    );

    return (
        <div className='h-10 flex items-center'>
            {tagElement}
        </div>
    );
};

export default PhoneStatus;
